// extracted by mini-css-extract-plugin
export default {"root":"_2EGMk","body-wrapper":"_2cAB8","bodyWrapper":"_2cAB8","big":"_19UR0","postfix":"_3XGU4","small":"_1DlXH","body-node":"_1S2Hn","bodyNode":"_1S2Hn"};